var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 129.01,
    height: 119.343,
    viewBox: "0 0 129.01 119.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.w{opacity:0.5;}.c{fill:url(#a);}.d{fill:#f2f2f2;}.e{fill:#e0e0e0;}.f,.i,.n{fill:#096a9a;}.f,.l{opacity:0.7;}.g{fill:#f5f5f5;}.h{clip-path:url(#d);}.i,.j{opacity:0.4;}.j{fill:#bdbdbd;}.k{fill:url(#h);}.l,.o{fill:#3ad29f;}.m{fill:url(#i);}.p{fill:#f55f44;}.q{fill:#fdd835;}.r{fill:url(#j);}.s{fill:url(#k);}.t{fill:url(#l);}.u,.w{fill:#47e6b1;}.v{fill:#4d8af0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.031,
    height: 14.851
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.518,
    y1: 1.092,
    x2: 0.518,
    y2: -0.251,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.6,
    y1: 0.66,
    x2: 0.6,
    y2: 0.086,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b3b3b3",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3",
    stopOpacity: 0.051
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.5,
    y1: 0.999,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#k"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(23.619 19.936)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 68.709,
    height: 92.33
  })), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 66.563,
    height: 89.109,
    transform: "translate(24.513 21.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.903,
    height: 0.716,
    transform: "translate(29.703 24.947)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 22.903,
    height: 0.716,
    transform: "translate(29.703 28.167)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.903,
    height: 0.716,
    transform: "translate(56.006 24.947)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.903,
    height: 0.716,
    transform: "translate(59.584 45.346)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.903,
    height: 0.716,
    transform: "translate(60.121 47.313)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.903,
    height: 0.716,
    transform: "translate(61.195 49.282)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.903,
    height: 0.716,
    transform: "translate(59.584 77.016)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.903,
    height: 0.716,
    transform: "translate(60.121 78.985)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.903,
    height: 0.716,
    transform: "translate(61.195 80.953)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(29.882 38.008)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24.334,
    height: 24.693
  })), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 23.951,
    height: 23.619,
    transform: "translate(30.035 38.546)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(30.88 39.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 22.339,
    height: 15.388
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.031,
    height: 14.851,
    transform: "translate(31.033 40.157)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(31.033 40.157)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M186.4,286.386l5.548-8.589,2.326,3.757,5.01-5.188,4.295,5.188,3.757-7.693,9.662,15.388-31.313-1.074Z",
    transform: "translate(-188.263 -272.07)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.61,
    cy: 1.61,
    r: 1.61,
    transform: "translate(0.817 0.536)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(29.882 69.68)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24.334,
    height: 24.693
  })), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 23.951,
    height: 23.619,
    transform: "translate(30.035 70.217)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(30.88 71.649)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 22.339,
    height: 15.388
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.031,
    height: 14.851,
    transform: "translate(31.033 71.827)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(31.033 71.827)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.4,493.086l5.548-8.589,2.326,3.758,5.01-5.19,4.295,5.19,3.757-7.695,9.662,15.388-31.313-1.073Z",
    transform: "translate(-188.263 -478.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 1.61,
    cy: 1.61,
    r: 1.61,
    transform: "translate(0.817 0.538)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(33.706 15.374)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 92.33,
    height: 68.709,
    transform: "translate(0 90.559) rotate(-78.76)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 89.109,
    height: 66.563,
    transform: "translate(34.967 104.177) rotate(-78.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 47.239,
    height: 0.716,
    transform: "translate(56.28 21.755) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 47.239,
    height: 0.716,
    transform: "translate(43.097 88.095) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 36.503,
    height: 0.716,
    transform: "translate(42.293 92.13) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 13.598,
    height: 0.716,
    transform: "translate(41.491 96.168) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 23.619,
    height: 0.716,
    transform: "translate(55.477 25.792) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 42.586,
    height: 0.716,
    transform: "translate(54.676 29.828) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 10.377,
    height: 0.716,
    transform: "translate(53.873 33.865) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 47.239,
    height: 0.716,
    transform: "translate(53.072 37.902) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(52.411 54.952)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 24.334,
    height: 42.406,
    transform: "translate(0 23.867) rotate(-78.76)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 41.87,
    height: 23.798,
    transform: "translate(57.39 55.18) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 47.239,
    height: 0.716,
    transform: "translate(52.27 41.94) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 5.19,
    height: 17.357,
    transform: "translate(61.063 59.193) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 5.19,
    height: 11.631,
    transform: "translate(69.072 66.623) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 5.19,
    height: 6.262,
    transform: "translate(77.153 73.703) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 5.19,
    height: 12.705,
    transform: "translate(87.535 69.198) rotate(11.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M653.487,370.035a23.884,23.884,0,1,0-3.907,36.382l17.266,17.959a1.163,1.163,0,0,0,1.644.032l4.3-4.137a1.163,1.163,0,0,0,.032-1.644L655.563,400.67A23.887,23.887,0,0,0,653.487,370.035Zm-5.378,28.874a17.084,17.084,0,1,1,.475-24.156,17.084,17.084,0,0,1-.475,24.156Z",
    transform: "translate(-546.012 -316.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M677.52,487.6a1.494,1.494,0,0,0,0,2.986A1.494,1.494,0,0,0,677.52,487.6Z",
    transform: "translate(-599.916 -422.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M703.54,425.149a14.35,14.35,0,0,0-12.379,6.394c-.817,1.278,1.5,2.407,2.314,1.135a11.835,11.835,0,0,1,10.266-5.194,13.078,13.078,0,0,1,10.672,6.207c.815,1.344,2.953.123,2.145-1.213A15.908,15.908,0,0,0,703.54,425.149Z",
    transform: "translate(-612.543 -369.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M665.717,364.115a23.884,23.884,0,1,0-3.907,36.38l17.265,17.96a1.163,1.163,0,0,0,1.644.032l4.3-4.137a1.163,1.163,0,0,0,.032-1.644l-17.266-17.959A23.887,23.887,0,0,0,665.717,364.115Zm-5.378,28.862a17.084,17.084,0,1,1,.475-24.156,17.084,17.084,0,0,1-.475,24.156Z",
    transform: "translate(-556.368 -311.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M689.75,481.67a1.494,1.494,0,0,0,0,2.986A1.494,1.494,0,0,0,689.75,481.67Z",
    transform: "translate(-610.272 -417.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M715.77,419.229a14.35,14.35,0,0,0-12.379,6.394c-.817,1.278,1.5,2.407,2.314,1.135a11.835,11.835,0,0,1,10.266-5.194,13.078,13.078,0,0,1,10.672,6.207c.815,1.344,2.953.123,2.145-1.214A15.852,15.852,0,0,0,715.77,419.229Z",
    transform: "translate(-622.899 -364.282)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 0.536,
    height: 3.041,
    transform: "translate(18.608 101.709)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 0.536,
    height: 3.041,
    transform: "translate(20.398 102.961) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M738.689,61.744a.657.657,0,0,1-.366-.8.314.314,0,0,0,.014-.074h0a.329.329,0,0,0-.593-.219h0a.318.318,0,0,0-.037.064.657.657,0,0,1-.8.366.316.316,0,0,0-.074-.014h0a.329.329,0,0,0-.216.6h0a.314.314,0,0,0,.064.037.657.657,0,0,1,.366.8.314.314,0,0,0-.014.074h0a.329.329,0,0,0,.6.216h0a.312.312,0,0,0,.037-.064.657.657,0,0,1,.8-.366.315.315,0,0,0,.074.014h0a.329.329,0,0,0,.219-.593h0A.317.317,0,0,0,738.689,61.744Z",
    transform: "translate(-651.068 -60.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M304.266,208.894a.657.657,0,0,1-.366-.8.318.318,0,0,0,.014-.074h0a.329.329,0,0,0-.593-.219h0a.315.315,0,0,0-.037.064.657.657,0,0,1-.8.366.316.316,0,0,0-.074-.014h0a.329.329,0,0,0-.219.593h0a.316.316,0,0,0,.064.037.657.657,0,0,1,.366.8.316.316,0,0,0-.014.074h0a.329.329,0,0,0,.593.219h0a.315.315,0,0,0,.037-.064.657.657,0,0,1,.8-.366.315.315,0,0,0,.074.014h0a.329.329,0,0,0,.219-.593h0A.316.316,0,0,0,304.266,208.894Z",
    transform: "translate(-283.208 -185.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M922.046,816.154a.657.657,0,0,1-.366-.8.317.317,0,0,0,.014-.074h0a.329.329,0,0,0-.593-.219h0a.314.314,0,0,0-.037.064.657.657,0,0,1-.8.366.315.315,0,0,0-.074-.014h0a.329.329,0,0,0-.219.593h0a.316.316,0,0,0,.064.037.657.657,0,0,1,.366.8.315.315,0,0,0-.014.074h0a.329.329,0,0,0,.593.219h0a.313.313,0,0,0,.037-.064.657.657,0,0,1,.8-.366.314.314,0,0,0,.074.014h0a.329.329,0,0,0,.219-.593h0A.316.316,0,0,0,922.046,816.154Z",
    transform: "translate(-806.332 -699.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 1.074,
    cy: 1.074,
    r: 1.074,
    transform: "translate(48.132 10.454)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 1.074,
    cy: 1.074,
    r: 1.074,
    transform: "translate(125.072 23.873)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "v",
    cx: 1.074,
    cy: 1.074,
    r: 1.074,
    transform: "translate(118.99 55.901)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 1.074,
    cy: 1.074,
    r: 1.074,
    transform: "translate(0 3.295)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.33e01bfcb125a82db20b1fb079fabe29.svg";
export { ForwardRef as ReactComponent };